import React from 'react';
import Icon from 'components/AppIcon';

function formatPHP(value) {
  if (value >= 1000000) return `₱${(value / 1000000)?.toFixed(1)}M`;
  if (value >= 1000) return `₱${(value / 1000)?.toFixed(0)}K`;
  return `₱${value?.toLocaleString()}`;
}

export default function RegionTooltip({ region, position, onClose }) {
  if (!region) return null;

  const isPositive = region?.growth >= 0;

  return (
    <div
      className="absolute z-50 rounded-xl shadow-xl p-4 w-64 pointer-events-none"
      style={{
        left: Math.min(position?.x + 12, window.innerWidth - 280),
        top: Math.max(position?.y - 20, 8),
        background: 'var(--color-popover)',
        border: '1px solid var(--color-border)',
        boxShadow: '0 10px 40px rgba(0,0,0,0.6), 0 0 0 1px rgba(220, 38, 38, 0.1)',
      }}
      role="tooltip"
    >
      <div className="flex items-start justify-between mb-3">
        <div>
          <h3 className="font-heading font-semibold text-foreground text-sm">{region?.name}</h3>
          <p className="font-caption text-xs text-muted-foreground">{region?.island} Group</p>
        </div>
        <span
          className={`flex items-center gap-0.5 text-xs font-medium px-2 py-0.5 rounded-full`}
          style={isPositive ? { background: 'rgba(34, 197, 94, 0.12)', color: '#22C55E', border: '1px solid rgba(34, 197, 94, 0.25)' } : { background: 'rgba(239, 68, 68, 0.12)', color: '#EF4444', border: '1px solid rgba(239, 68, 68, 0.25)' }}
        >
          <Icon name={isPositive ? 'TrendingUp' : 'TrendingDown'} size={10} color="currentColor" strokeWidth={2.5} />
          {isPositive ? '+' : ''}{region?.growth}%
        </span>
      </div>
      <div className="grid grid-cols-2 gap-2 mb-3">
        {[
          { label: 'Revenue', value: formatPHP(region?.revenue), color: '#DC2626' },
          { label: 'Orders', value: region?.orders?.toLocaleString(), color: '#D4AF37' },
          { label: 'Accounts', value: region?.accounts, color: '#22C55E' },
          { label: 'Coverage', value: `${region?.coverage}%`, color: '#8B92A5' },
        ]?.map((item) => (
          <div key={item?.label} className="rounded-lg p-2" style={{ background: 'var(--color-muted)', border: '1px solid var(--color-border)' }}>
            <p className="font-caption text-xs text-muted-foreground">{item?.label}</p>
            <p className="font-data text-sm font-semibold" style={{ color: item?.color }}>{item?.value}</p>
          </div>
        ))}
      </div>
      <div>
        <p className="font-caption text-xs text-muted-foreground mb-1.5">Top Products</p>
        <div className="flex flex-col gap-1">
          {region?.topProducts?.slice(0, 3)?.map((product, idx) => (
            <div key={idx} className="flex items-center justify-between">
              <span className="font-caption text-xs text-foreground truncate flex-1">{product?.name}</span>
              <span className="font-data text-xs text-muted-foreground ml-2 flex-shrink-0">{product?.share}%</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}